import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../features/auth/auth.store';

/**
 * Route guard for this portal — unlike the mobile app (which has public
 * pages and checks auth inline per-page), everything here except /login
 * requires a signed-in therapist, so a single wrapper is simpler than
 * repeating the check on every page.
 */
export function RequireAuth({ children }: PropsWithChildren) {
  const accessToken = useAuthStore((s) => s.tokens?.accessToken);
  if (!accessToken) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
